import Constants from "@/constants";

export const CURRENT_ENV: "test" | "prod" | "pre" = (() => {
  if (Constants.IS_DEV || Constants.IS_DEBUG) return "test";
  if (location.origin.includes("pre")) return "pre";
  return "prod";
})();

/**
 * @description 环境选择，匹配测试、预发布、正式环境。
 * - 仅适用于当前项目为 hd.huya.com/* 域名的项目
 * - 雅典娜部署或其他部署的项目，需注意预发布环境链接是否有 pre 关键词
 */
export const selectEnv = <T>(params: {
  /** 测试 */
  test: T;

  /** 正式 */
  prod: T;

  /** 预发 */
  pre: T;
}): T => {
  return params[CURRENT_ENV];
};

/** 获取充值虎牙币 h5 链接 */
export const getPayHYBUrl = () => {
  // # 充值虎牙币 h5

  // 测试环境: https://test-hd.huya.com/h5/pay-hyb/test/index.html

  // 预发环境: https://pre-hd.huya.com/h5/pay-hyb/index.html

  // 正式环境: https://hd.huya.com/h5/pay-hyb/index.html

  return selectEnv({
    test: `https://test-hd.huya.com/h5/pay-hyb/test/index.html`,
    pre: `https://pre-hd.huya.com/h5/pay-hyb/index.html`,
    prod: `https://hd.huya.com/h5/pay-hyb/index.html`,
  });
};
